import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Privacy Policy placeholder page.
 * Required for Microsoft Teams app manifest.
 */
export const PrivacyPage: React.FC = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
        Privacy Policy
      </h1>

      <div className="prose dark:prose-invert max-w-none">
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          <strong>Last updated:</strong> {new Date().toLocaleDateString()}
        </p>

        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-4">
          Data Collection
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          Client Dashboards processes uploaded advertising report files to generate analytics
          and insights. Files are processed in memory and are not permanently stored on our servers.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-4">
          Data Usage
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          Uploaded data is used solely for generating the analytics dashboard and AI-powered
          insights. We do not share, sell, or distribute your data to third parties.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-4">
          Third-Party Services
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          This application uses OpenAI services for generating AI insights. Data sent to
          OpenAI is subject to their privacy policy.
        </p>

        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mt-8 mb-4">
          Contact
        </h2>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          For privacy-related inquiries, please contact your organization administrator.
        </p>
      </div>

      <div className="mt-12">
        <Link
          to="/upload"
          className="text-indigo-600 dark:text-indigo-400 hover:underline"
        >
          &larr; Back to Dashboard
        </Link>
      </div>
    </div>
  );
};
